<style scoped>

</style>
<template>
    <div></div>
</template>
<script>
    import Consumer from './libs/consumer';

    export default {
        data(){
            return {
                //
            }
        },
        computed: {
            cur_customer(){
                return this.$store.state.cur_customer;
            },
        },
        created(){
            this.init();
        },
        mounted(){
            //
        },
        methods: {
            init() {
                this.notice_channel = Consumer.subscriptions.create({channel: 'NoticeChannel'}, {
                    received: (data) => {
                        console.log('notice:', data);
                    }
                });
                setTimeout(() => {
                    this.notice_channel.send({sent_by: this.cur_customer.account, timestamp: new Date().getTime(), sss: 'sss'});
                }, 3000);
            },
        }
    }
</script>
